<template>
	<v-card>
		<v-card-title>
			<div><span class="headline">مدیریت تعریف وضعیت درخواست ها</span></div>
			<v-spacer />
			<v-btn class="" small color="secondary" dark @click="dialogSmsPatternManager = true">
				مدیریت قالب های پیامک
			</v-btn>
			<v-btn @click="$emit('close')" icon>
				<v-icon>mdi-close</v-icon>
			</v-btn>
		</v-card-title>
		<v-card-text>
			<div>
				<div v-if="loading">
					<div class="success--text text-h4 text-center">
						در حال دریافت اطلاعات...
					</div>
				</div>
				<div v-else>
					<div v-if="!items.length">
						<h3 class="text-center red--text">لیست وضعیت ها خالی است</h3>
						<div class="text-center mt-5">
							<v-btn class="mx-auto" color="secondary" dark @click="add">
								<v-icon dark>
									mdi-plus-circle-outline
								</v-icon>
								افزودن وضعیت
							</v-btn>
						</div>
					</div>
					<div v-else>
						<v-card v-for="(item, index) in items" :key="item.id + index" class="mb-3" elevation="0" style="border: 1px solid #dca6e5">
							<div class="pa-2 d-flex align-center">
								<div>
									<div class="grey--text"><small>عنوان وضعیت:</small></div>
									<v-text-field class="ml-2 pt-0 mt-0" :disabled="!item.editMode" v-model="item.title" label="" :error-messages="errorMessages" :rules="[(val) => !!val || 'عنوان وضعیت را وارد کنید']" required />
								</div>

								<div>
									<div class="grey--text" v-if="statusGroup === 0"><small>جایگاه:</small></div>
									<v-select class="ml-2 pt-0 mt-0" v-if="statusGroup === 0" :disabled="!item.editMode" v-model="item.stepCategory" required :items="stepCategorys" label="" single-line item-text="title" item-value="id" />
								</div>

								<div>
									<div class="grey--text"><small>قالب پیامک:</small></div>
									<v-combobox class="ml-2 pt-0 mt-0" :disabled="!item.editMode" v-model="item.smsPattern" clearable :items="smsPatterns" label="" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
								</div>

								<div style="width: 200px;">
									<v-checkbox class="ml-2 py-0 my-0 small" hide-details dense small v-if="statusGroup === 0" :disabled="!item.editMode" color="secondary" v-model="item.changable" label="قابل تغییر و حذف؟" />
									<v-checkbox class="ml-2 py-0 my-0 small" hide-details dense small v-if="statusGroup === 0" :disabled="!item.editMode" color="secondary" v-model="item.allowNewRequest" label="اجازه درخواست تکراری" />
								</div>

								<v-btn v-if="!item.editMode" @click="edit(item)" class="ms-2 ml-1" x-small fab dark color="secondary" title="ویراش">
									<v-icon dark>
										mdi-square-edit-outline
									</v-icon>
								</v-btn>
								<v-btn v-if="!item.editMode" @click="remove(item, index)" class="ms-2 ml-1" x-small fab dark color="pink" title="حذف">
									<v-icon dark>
										mdi-trash-can-outline
									</v-icon>
								</v-btn>
								<v-btn :loading="submitLoading" @click="save(item, index)" class="ms-2 ml-1" title="ذخیره" v-if="item.editMode" color="success" fab x-small dark>
									<v-icon dark>
										mdi-check
									</v-icon>
								</v-btn>
								<v-btn class="ms-2 ml-1" @click="cancel(item, index)" v-if="item.editMode" title="انصراف" color="grey" fab x-small dark>
									<v-icon dark>
										mdi-close
									</v-icon>
								</v-btn>

							</div>
						</v-card>
						<div class="text-center mt-5">
							<v-btn class="mx-auto" color="secondary" dark @click="add">
								<v-icon dark>
									mdi-plus-circle-outline
								</v-icon>
								افزودن وضعیت جدید
							</v-btn>
						</div>
					</div>
				</div>

				<confirm-dlg ref="confirm" />
			</div>
		</v-card-text>

		<v-dialog v-model="dialogSmsPatternManager" scrollable persistent max-width="450px">
			<v-card>
				<v-card-title>
					<div><span class="headline">مدیریت قالب های پیامک</span></div>
					<v-spacer />
					<v-btn @click="dialogSmsPatternManager = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<sms-pattern-manager ref="smsPatternManager" v-if="dialogSmsPatternManager" @itemsUpdated="updatePatterns" group="requestStatus" :category="1" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

	</v-card>
</template>

<script>
	import api from '@/util/app-api'
	import { emptyId } from '@/util/emptyId'
	import toast from '@/util/toast'
	import { call, get } from 'vuex-pathify'
	import _ from 'lodash'

	export default {
		name: 'LoanRequestStatuses',
		props: {
			data: { type: Object },
			statusGroup: { type: Number, required: true },
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'sms-pattern-manager': () => import('@/components/SmsPatternManager.vue'),
		},
		data() {
			return {
				emptyId: emptyId,
				dialogSmsPatternManager: false,
				smsPatterns: [],
				errorMessages: '',
				items: [],
				localData: {},
				submitLoading: false,
				loading: false,
				stepCategorys: [{
					id: 0,
					title: 'قبل از تکمیل مدارک'
				},
				{
					id: 5,
					title: 'تکمیل مدارک'
				},
				{
					id: 10,
					title: 'بعد از تکمیل مدارک'
				}]
			}
		},
		computed: {
		},
		mounted() {
			this.loadSmsPatterns()
			this.loadData()
		},
		methods: {
			fetchLoanRequestStatus: call('loanRequestStatus/fetch'),
			loadData(force = false) {
				this.fetchLoanRequestStatus({ force: force }).then(items => {
					this.items = _.cloneDeep(items.filter(x => x.statusGroup === this.statusGroup)).map(x => {
						x.editMode = false
						return x
					})
				})
			},
			loadSmsPatterns() {
				api.get('admin/smsPattern/list', null)
					.then(
						response => {
							this.smsPatterns = response.filter(x => x.status === 1)
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => {
					})
			},
			updatePatterns(items) {
				this.smsPatterns = items.filter(x => x.status === 1)
			},
			edit(item) {
				item.editMode = true
				item.original = JSON.parse(JSON.stringify(item))
			},
			save(item, index) {
				this.submitLoading = true
				var clone = { ...item }
				//clone.systemType = item.systemType.id
				api.post('admin/LoanRequestStatus/' + (item.id === emptyId ? 'create' : 'edit'), clone)
					.then(response => {
						toast.success('اطلاعات با موفقیت ذخیره شد.')
						item.editMode = false
						this.loadData(true)
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.submitLoading = false })
			},
			cancel(item, index) {
				if (item.id == emptyId) {
					this.items.splice(index, 1)
					return
				}
				item.title = item.original?.title
				item.changable = item.original?.changable
				item.allowNewRequest = item.original?.allowNewRequest
				item.order = item.original?.order
				item.smsPattern = item.original?.smsPattern
				item.stepCategory = item.original?.stepCategory
				item.editMode = false
			},
			async remove(item, index) {
				if (!item) {
					return
				}

				if (item.id == emptyId) {
					this.items.splice(index, 1)
					return
				}

				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این آیتم مطمئن هستید؟',
				)) {
					api.post('admin/LoanRequestStatus/delete/' + item.id)
						.then(response => {
							toast.success('اطلاعات با موفقیت حذف شد.')
							this.loadData(true)
						})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
			add() {
				let newItem = {
					id: emptyId,
					title: '',
					stepCategory: 0,
					changable: false,
					order: this.items.length ? this.items.length * 2 : 0,
					smsPattern: null,
					editMode: true,
					statusGroup: this.statusGroup
				}
				this.items.push(newItem)
			},
		},
	}
</script>
<style></style>
